/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selected_LanguagesInputs */

const en_selected_languages = /** @type {(inputs: Selected_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected Languages`)
};

const fr_selected_languages = /** @type {(inputs: Selected_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langues sélectionnées`)
};

const de_selected_languages = /** @type {(inputs: Selected_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Sprachen`)
};

const it_selected_languages = /** @type {(inputs: Selected_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingue selezionate`)
};

const ru_selected_languages = /** @type {(inputs: Selected_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Избранные языки`)
};

const es_selected_languages = /** @type {(inputs: Selected_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas seleccionados`)
};

const zh_cn2_selected_languages = /** @type {(inputs: Selected_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选定语言`)
};

const ja_selected_languages = /** @type {(inputs: Selected_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択された言語`)
};

const hi_selected_languages = /** @type {(inputs: Selected_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित भाषाएँ`)
};

const pt_pt2_selected_languages = /** @type {(inputs: Selected_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas selecionados`)
};

/**
* | output |
* | --- |
* | "Selected Languages" |
*
* @param {Selected_LanguagesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const selected_languages = /** @type {((inputs?: Selected_LanguagesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selected_LanguagesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_selected_languages(inputs)
	if (locale === "de") return de_selected_languages(inputs)
	if (locale === "it") return it_selected_languages(inputs)
	if (locale === "ru") return ru_selected_languages(inputs)
	if (locale === "es") return es_selected_languages(inputs)
	if (locale === "zh-CN") return zh_cn2_selected_languages(inputs)
	if (locale === "ja") return ja_selected_languages(inputs)
	if (locale === "hi") return hi_selected_languages(inputs)
	if (locale === "pt-PT") return pt_pt2_selected_languages(inputs)
	return en_selected_languages(inputs)
});